export const QA_NAME_WIDGET_HEADER_EXPAND_BTN = 'widgetHeaderExpand'
